import { Constants } from '@leverege/molten-core';
import AttributesSetup from "./attributes/PluginSetup.js";
import BlueprintRouteCreator from "./BlueprintRouteCreator.js";
import UserAccessCreator from "./UserAccessCreator.js";
import TemporaryUserAccessCreator from "./TemporaryUserAccessCreator.js";
import ApiAccessCreator from "./ApiAccessCreator.js";
import MapPlugins from "./map/PluginSetup.js";
import GoogleMapPlugins from "./googleMap/PluginSetup.js";
import SelectionHook from "./dataSource/SelectionHook.js";
import Forms from "./forms/PluginSetup.js";
import DefaultInitialRouteCreator from "./DefaultInitialRouteCreator.js";
import TableCellRendererCreator from "./TableCellRendererCreator.js";
import SimpleSearchRouteCreator from "./simpleSearch/SimpleSearchRouteCreator.js";
import LoadHierarchyBlocker from "./blockers/LoadHierarchyBlocker.js";
import GroupingsSetup from "./groupings/PluginSetup.js";
import SystemUserAccess from "./SystemUserAccess.js";
import Filters from "./filters/PluginSetup.js";
import History from "./history/PluginSetup.js";
import ColorizersSetup from "./colorizers/PluginSetup.js";
import VisibilizersSetup from "./visibilizers/PluginSetup.js";
import HistoryAggregationAttributeCreator from "./attributeCreators/HistoryAggregationAttributeCreator.js";
import TimeSinceTimestampAttributeCreator from "./attributeCreators/TimeSinceTimestampAttributeCreator.js";
import VariantizersSetup from "./variantizers/PluginSetup.js";
import SymbolizerSetup from "./symbolizers/PluginSetup.js";
import UrlMutators from "./dataSource/urlMutators/PluginSetup.js";
const {
  LOGGED_IN,
  BLUEPRINTS_PROCESSOR,
  BLUEPRINT_RELATIONSHIP_PROCESSOR
} = Constants;
const install = molten => {
  molten.addPlugin(LOGGED_IN, SystemUserAccess);
  molten.addPlugin(BLUEPRINT_RELATIONSHIP_PROCESSOR, BlueprintRouteCreator);
  molten.addPlugin(BLUEPRINT_RELATIONSHIP_PROCESSOR, SimpleSearchRouteCreator);
  molten.addPlugin(BLUEPRINT_RELATIONSHIP_PROCESSOR, UserAccessCreator);
  molten.addPlugin(BLUEPRINT_RELATIONSHIP_PROCESSOR, TemporaryUserAccessCreator);
  molten.addPlugin(BLUEPRINT_RELATIONSHIP_PROCESSOR, ApiAccessCreator);
  molten.addPlugin(BLUEPRINT_RELATIONSHIP_PROCESSOR, DefaultInitialRouteCreator);
  molten.addPlugin(BLUEPRINTS_PROCESSOR, TableCellRendererCreator);
  molten.addPlugin('BlockerHook', LoadHierarchyBlocker);
  AttributesSetup.install(molten);
  SelectionHook.install();
  MapPlugins.install(molten);
  GoogleMapPlugins.install(molten);
  Forms.install(molten);
  GroupingsSetup.install(molten);
  Filters.install(molten);
  History.install(molten);
  ColorizersSetup.install(molten);
  VisibilizersSetup.install(molten);
  molten.addPlugin('AttributeCreator', HistoryAggregationAttributeCreator);
  molten.addPlugin('AttributeCreator', TimeSinceTimestampAttributeCreator);
  VariantizersSetup.install(molten);
  SymbolizerSetup.install(molten);
  UrlMutators.install(molten);
};
export default {
  install
};